import * as React from 'react';

import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
  Stack,
  Divider,
  Typography,
  Tooltip,
  IconButton,
} from '@mui/material';

import FormAvatar from '../FormAvatar';
import NarrativeTooltip from '../NarrativeTooltip';

import getFullDate from '../../core/common/utils';
import { getAvatarText, getFormName } from '../Utility/MetaDataHelpers';
import { useIncidentReportData } from '../../core/context/IncidentReportDataContext';
import { EventReport } from '../../core/api/clients';
import ReportOrder from '../Enums/ReportOrder';

interface IncidentFormReportListItemProps {
  report: EventReport;
  enableSecondaryAction: boolean;
  hideSecondaryAction?: boolean;
  secondaryAction: () => void;
  secondaryActionIcon: React.ReactNode;
  secondaryActionTitle: string;
}

function IncidentFormReportListItem({
  report,
  enableSecondaryAction,
  hideSecondaryAction = false,
  secondaryAction,
  secondaryActionIcon,
  secondaryActionTitle,
}: IncidentFormReportListItemProps) {
  const { getFormColor } = useIncidentReportData();

  return (
    <ListItem
      dense
      divider
      secondaryAction={(!hideSecondaryAction
        && (
        <Tooltip title={secondaryActionTitle} placement="top-end">
          <IconButton onClick={secondaryAction} disabled={!enableSecondaryAction}>
            {secondaryActionIcon}
          </IconButton>
        </Tooltip>
        )
      )}
    >
      <ListItemAvatar>
        <FormAvatar
          color={getFormColor(report.reportType!)}
          title={getAvatarText(report.reportType)}
          hasDecorator={report.order === ReportOrder.FER_Captain}
          style={{ width: 40, height: 25, fontSize: 12 }}
        />
      </ListItemAvatar>
      <ListItemButton
        target="_blank"
        href={`form/${getFormName(report.reportType)}/${report.id}/view`}
      >
        <ListItemText
          disableTypography
          primary={(
            <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
              <Typography variant="body1">{report.eventType2}</Typography>
              <Typography variant="body1">{report.aircraftNumber}</Typography>
              <Typography variant="body1">{report.flightNumber}</Typography>
              <Typography variant="body1">{report.departureAirport}</Typography>
              <Typography variant="body1">{report.scheduledArrivalAirport}</Typography>
              <Typography variant="body1">{getFullDate(report.eventDate)}</Typography>
            </Stack>
          )}
          secondary={(
            <NarrativeTooltip narrative={report.narrative ?? ''} cutoffWidth={80} />
          )}
        />
      </ListItemButton>
    </ListItem>
  );
}

export default IncidentFormReportListItem;
